import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { orientationMode } from '../../../util/objects';
import '../css/separator.scss';

const Separator = ({ orientation }) => {
    const orientationClass = orientation === orientationMode.vertical ? 'separator--vertical' : 'separator--horizontal';

    return <div className={`separator ${orientationClass}`}>&nbsp;</div>;
};

export default withStyles({})(Separator);
